var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _linearGradient3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploymentTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_d5d5fc6365d1b245fd294549189f080d212d99a8ed7194283876c5a8d2402293",
    gradientUnits: "userSpaceOnUse",
    x1: 1279.48,
    y1: -719.132,
    x2: 1280.48,
    y2: -719.132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M141.359 98.581V69.884h8.201M57.848 98.581V69.884h-8.2M65.699 58.569v32.83M133.501 58.65v32.83M68.605 99.322l59.442 28.979M128.047 99.322l-59.442 28.979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M57.848 91.963h83.22v6.977h-83.22z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_d5d5fc6365d1b245fd294549189f080d212d99a8ed7194283876c5a8d2402293",
    gradientUnits: "userSpaceOnUse",
    x1: 64.458,
    y1: 45.869,
    x2: 134.788,
    y2: 45.869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.538 59.036c-6.642 4.041-19.145 5.654-33.475 5.654-14.99 0-27.981-1.869-34.355-6.221V27.048c6.374 4.351 19.365 6.221 34.355 6.221 14.33 0 26.833-1.613 33.475-5.654v31.421z",
    fill: "none",
    stroke: "url(#SVGID_1_d5d5fc6365d1b245fd294549189f080d212d99a8ed7194283876c5a8d2402293)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M120.19 53.734c-4.091 1.806-11.793 2.526-20.619 2.526-9.233 0-17.236-.835-21.162-2.779V39.442c3.926 1.944 11.928 2.779 21.162 2.779 8.827 0 16.528-.72 20.619-2.526v14.039z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_d5d5fc6365d1b245fd294549189f080d212d99a8ed7194283876c5a8d2402293",
    gradientUnits: "userSpaceOnUse",
    x1: 29.924,
    y1: 128.962,
    x2: 169.377,
    y2: 128.962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_d5d5fc6365d1b245fd294549189f080d212d99a8ed7194283876c5a8d2402293)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M168.127 128.962H31.174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentTemplates);
export default __webpack_public_path__ + "static/media/employmentTemplates.ce36c64e77bb0980485e4f439c1fb8e2.svg";
export { ForwardRef as ReactComponent };